import React, { type ReactElement } from 'react'
import { Box, Grid, Typography } from '@mui/material'

const ReviewCeil = ({ name, value }: { name: string; value: ReactElement }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        padding: '12px 16px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '4px',
        flex: 1,
        borderRadius: '8px',
        background: 'var(--color-white-3)',
      }}
    >
      <Grid item xs={12}>
        <Typography variant="body2" fontSize={14} fontWeight={500} lineHeight="20px" color="var(--color-600)">
          {name}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {value}
      </Grid>
    </Box>
  )
}

export default ReviewCeil
